import { render } from "./EditingHistory.vue?vue&type=template&id=8f9cb600"
import script from "./EditingHistory.vue?vue&type=script&lang=js"
export * from "./EditingHistory.vue?vue&type=script&lang=js"
script.render = render

export default script